<div class="w-full h-full max-h-[90vh] bg-[#1a1a1a] text-white overflow-hidden flex flex-col rounded-lg">
  <!-- Header -->
  <div class="sticky top-0 z-10 bg-[#1a1a1a]/95 backdrop-blur-sm border-b border-zinc-800">
    <div class="flex items-center justify-between px-6 py-4">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-[#E4811E]/20 flex items-center justify-center">
          <mat-icon svgIcon="heroicons_outline:document-text" class="text-[#E4811E] icon-size-5"></mat-icon>
        </div>
        <div>
          <span class="text-white/50 text-xs uppercase tracking-wider">Comprovante</span>
          <p class="text-[#E4811E] text-sm font-medium">{{ data.titulo }}</p>
        </div>
      </div>
      <button
        mat-icon-button
        class="text-white/60 hover:text-white hover:bg-zinc-800 transition-colors"
        (click)="fechar()">
        <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Conteúdo Principal -->
  <div class="flex-1 overflow-hidden p-4">
    <!-- Loading -->
    @if (isLoading) {
      <div class="flex items-center justify-center h-full">
        <div class="flex flex-col items-center gap-4">
          <mat-spinner diameter="48" color="primary"></mat-spinner>
          <p class="text-white/50">Carregando comprovante...</p>
        </div>
      </div>
    }

    <!-- Erro -->
    @if (errorMessage && !isLoading) {
      <div class="flex items-center justify-center h-full">
        <div class="flex flex-col items-center gap-4 text-center">
          <div class="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 icon-size-8"></mat-icon>
          </div>
          <p class="text-red-400">{{ errorMessage }}</p>
        </div>
      </div>
    }

    <!-- PDF Viewer -->
    @if (pdfUrl && !isLoading && !errorMessage) {
      <div class="w-full h-full rounded-lg overflow-hidden bg-zinc-900">
        <iframe
          [src]="pdfUrl"
          class="w-full h-full min-h-[500px]"
          frameborder="0">
        </iframe>
      </div>
    }
  </div>

  <!-- Footer com botões -->
  <div class="border-t border-zinc-800 px-6 py-4 flex justify-between items-center">
    <button
      mat-flat-button
      class="bg-zinc-700 hover:bg-zinc-600 text-white"
      (click)="fechar()">
      <mat-icon svgIcon="heroicons_outline:x-mark" class="mr-2 icon-size-4"></mat-icon>
      Fechar
    </button>

    <button
      mat-flat-button
      color="primary"
      [disabled]="!pdfUrl || isLoading"
      (click)="downloadPdf()">
      <mat-icon svgIcon="heroicons_outline:arrow-down-tray" class="mr-2 icon-size-4"></mat-icon>
      Download
    </button>
  </div>
</div>
